export default __webpack_public_path__ + "static/lozenge-do-1-light-3e88f4d3488094940e999c816e6fdf2ed66b00a63069ab090d37bb23769349cf.png";